import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/lib/i18n";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("auk_lang") || "pt");
  useEffect(() => { localStorage.setItem("auk_lang", lang); }, [lang]);
  const t = (k) => translations[lang]?.[k] ?? translations.pt[k] ?? k;
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
